import { z } from "zod";
export const workflowExecutionEnvironmentSchema = z.object({
    runtimeVersion: z.literal("workflow-python-2"),
    /** The served release: a fleet release's commit, or a local instance's revision digest of its build inputs. */
    runtimeRelease: z.string().regex(/^(?:[0-9a-f]{40}|[0-9a-f]{64})$/u).optional(),
    judgmentModel: z.string().regex(/^jev-\d+\.\d+\.\d+$/u).nullable(),
}).strict();
export const workflowExecutionSnapshotSchema = z.object({
    id: z.string().regex(/^[0-9a-f]{64}$/u),
    evaluatedAt: z.number().int().positive(),
    environment: workflowExecutionEnvironmentSchema,
}).strict();
export const workflowMemoSchema = z.object({
    nodeId: z.string().regex(/^[A-Za-z_][A-Za-z0-9_]{0,63}$/u),
    /** `second_reader` is the platform's Twin Judge reading of a review, keyed by its proposal effect. */
    stage: z.enum(["program", "judgment", "effect", "node", "second_reader"]),
    effectKey: z.string().min(1).max(64).optional(),
    requestHash: z.string().regex(/^[0-9a-f]{64}$/u),
    value: z.json().refine(value => new TextEncoder().encode(JSON.stringify(value)).length <= 1_048_576, "Step evidence exceeds 1 MiB").optional(),
}).strict();
